var exports = {
  "N1": "headerContainer-b1hNO",
  "dW": "underlined-b1hNO",
  "BB": "light-b1hNO",
  "T5": "ghosted-b1hNO",
  "Rm": "secondary-b1hNO",
};

module.exports = exports;
